import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import FailedIcon from '../../../../../assets/icons/mobile-fail-icon.png';
import SuccessIcon from '../../../../../assets/icons/mobile-success-icon.png';
import {questionToastsSelector} from '../../../../store/selectors/questionToast.selectors';
import {removeToastAction} from '../../../../store/actions/questionToast.actions';
import {IQuestionAnswerType} from '../../../../incase-domain/elements/base/questionElementBase';
import {usePlayerLabels} from '../../../../hooks/usePlayerLabels';

export function QuestionAnswerHeader(): JSX.Element {
    const dispatch = useDispatch();

    const [timer, setTimer] = useState<{time: ReturnType<typeof setTimeout>; isShort: boolean; id: string}>();
    const [isClosing, setIsClosing] = useState(false);

    const toasts = useSelector(questionToastsSelector);
    const getLabelTranslation = usePlayerLabels();

    const currentToast = toasts[0];

    useEffect(() => {
        if (toasts.length > 1) {
            if (!timer?.isShort) {
                clearTimeout(timer?.time);
                setIsClosing(true);

                setTimer({
                    time: setTimeout(() => {
                        dispatch(removeToastAction(toasts[0].questionId));
                        setIsClosing(false);
                    }, 500),
                    isShort: true,
                    id: toasts[0].questionId,
                });
            } else if (timer?.id !== toasts[0].questionId) {
                setTimer({
                    time: setTimeout(() => {
                        setIsClosing(true);
                        setTimeout(() => {
                            dispatch(removeToastAction(toasts[0].questionId));
                            setIsClosing(false);
                        }, 500);
                    }, 750),
                    isShort: true,
                    id: toasts[0].questionId,
                });
            }
        } else if (toasts[0]) {
            setTimer({
                time: setTimeout(() => {
                    setIsClosing(true);

                    setTimeout(() => {
                        dispatch(removeToastAction(toasts[0].questionId));
                        setIsClosing(false);
                    }, 350);
                }, 1000),
                isShort: false,
                id: toasts[0].questionId,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toasts]);

    function iconSrc(type: IQuestionAnswerType): string {
        if (type === 'incorrect') return FailedIcon;
        if (type === 'correct') return SuccessIcon;

        return SuccessIcon;
    }

    function i18nBody(type: IQuestionAnswerType): string | undefined {
        if (type === 'incorrect') return getLabelTranslation('toast-answer-incorrect');
        if (type === 'correct') return getLabelTranslation('toast-answer-correct');

        return getLabelTranslation('toast-answer-debatable');
    }

    return (
        <>
            {currentToast && (
                <div
                    className={`c-questionAnswerHeader ${isClosing ? 'is-closing' : 'is-opening'} ${
                        (currentToast.type === 'incorrect' && 'is-error') || (currentToast.type === 'debatable' && 'is-debatable')
                    }`}
                >
                    <div className="c-questionAnswerHeader__body">
                        <div>
                            <img src={iconSrc(currentToast.type)} alt="answered question icon" />
                        </div>

                        <div>
                            <div>{i18nBody(currentToast.type)}</div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
